<div *ngIf="show" class="cookies-banner" @slideToggle>
  <div class="banner-wrap">
    <a class=" fa-rectangle-xmark fa-xmark lead" (click)="close()"></a>
    <div class="text">
      <p class="m-0">
        {{ landingCookiesBanner }}
      </p>
      <p class="m-0">
        {{ landingCookiesBannerCont }}
        <a [routerLink]="['/content/', CMS.COOKIES]" target="_blank" class="cookies-policy-link">{{
          landingCookiesPolicy
        }}</a>
      </p>
    </div>
  </div>
</div>
